import { findScrollParent } from './find-scroll-parent.js';

/** The top and bottom edges of the box that scrolls the element: its nearest scrolling ancestor, else the window. */
export function scrollViewportBounds(element: HTMLElement): { top: number; bottom: number } {
  const parent = findScrollParent(element, { overflowingOnly: true });
  if (!parent) return { top: 0, bottom: window.innerHeight };
  const { top, bottom } = parent.getBoundingClientRect();
  return { top, bottom };
}
